import React from "react";

const Export = () => {
	return (
		<div className="export_div">
			<div className="bg-card fs-16 status-card px-3">
				<i className="fas fa-download fs-16 s-icon"></i>
				<div className="lc fs-20 px-2 sc">Export</div>
			</div>
		</div>
	);
};

export default Export;
